<template>
  <div class="page">
    <div class="navbar navbar-style-1 navbar-transparent">
      <div class="navbar-inner">
        <router-link :to="{ name: 'home'}" class="link back">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.439312 13.0606L5.75391 18.3752C6.04683 18.6682 6.43069 18.8146 6.81459 18.8146C7.1985 18.8146 7.58236 18.6682 7.87528 18.3752C8.46103 17.7894 8.46103 16.8397 7.87528 16.2539L5.12133 13.5H22.5C23.3284 13.5 24 12.8284 24 12C24 11.1716 23.3284 10.5 22.5 10.5H5.12133L7.87528 7.7461C8.46103 7.1603 8.46103 6.21057 7.87528 5.62477C7.28944 5.03898 6.33975 5.03898 5.75391 5.62477L0.439312 10.9394C-0.146437 11.5251 -0.146437 12.4749 0.439312 13.0606Z" fill="black"/>
          </svg>
        </router-link>
        <div class="title"></div>
        <div class="right">

        </div>
      </div>
    </div>

    <div class="page-content pt-0">

      <div class="rewards-box container" id="promotion-header" v-bind:style="{ 'background-color': $props.color }" style="background-image: url(img/background/card-bg.png);">
        <div class="dz-media">
          <img v-if="$props.image_url" v-bind:src="$props.image_url" alt="" style="max-height: 150px;">
        </div>
        <h4 class="title">{{$props.name}}</h4>
      </div>
      <div class="container pt-30 pb-15">
        <div v-if="description">
          <span v-html="description"></span>
        </div>
        <div v-else>
          <PuSkeleton height="15px" />
          <PuSkeleton height="15px" />
          <PuSkeleton height="15px" />
          <PuSkeleton height="15px" />
          <PuSkeleton height="15px" />
          <PuSkeleton height="15px" />
          <PuSkeleton height="15px" />
          <PuSkeleton height="15px" />
          <PuSkeleton height="15px" />
          <PuSkeleton height="15px" />
          <PuSkeleton height="15px" />
          <PuSkeleton height="15px" />
          <PuSkeleton height="15px" />
          <PuSkeleton height="15px" />
          <PuSkeleton height="15px" />
        </div>
      </div>

    </div>

  </div>
</template>

<script>
// import {BASE_API_URL} from "../appConstants";
// import axios from "axios";
// import router from "../router/router";

import {BASE_API_URL} from "../appConstants";
import axios from "axios";

export default {
  name: "Promotion",
  props: ['id', 'name', 'image_url', 'color'],
  data(){
    return{
      activeRating: 0,
      message: "",
      description: null
    }
  },
  created(){
    this.getDescription();
  },
  methods:{
    getDescription () {
      const endpoint = BASE_API_URL +
          'get-promotion-description?id='+ this.$props.id +
          '&pref_lang_code=' + this.$store.state.prefLangCode;

      axios.get(endpoint).then(
          response => {
            this.description = response.data.content;
          }
      ).catch(error => {
        console.log(error);
      })
    }
  }
}
</script>

<style scoped>


</style>
